export default __webpack_public_path__ + "static/media/coveredBanner.1699fc79.png";